export const API_URL = "https://vqoesmzgmb.execute-api.eu-west-2.amazonaws.com/Prod";
// export const API_URL = "https://localhost:8073"
//export const API_URL = "https://localhost:44344";
//export const API_URL = "https://service.computerdevelopment.co.uk"
//export const API_URL = "https://service.centralbodyshop.co.uk"